export const PledgeEstateFormTexts = {
  fillByNumber: 'Заполнить по номеру',
  alertText: 'Для принятия решения по кредитам под залог, банку необходима информация о вашей недвижимости',
  loadCarInfo: 'Подгрузить данные',
  carInfoLoaded: 'Данные загружены',
  carInfoNotLoaded: 'Не смогли найти информацию о машине',
  tryLoadCarInfoAgain: 'Попробовать ещё раз',
  // labels
  pledgeEstateAddress: 'Населенный пункт, улица, дом',
  pledgeEstateAddressFlat: 'Квартира',
  isOnlyOwner: 'Я единственный собственник',
  otherOwnerFullName: 'ФИО другого собственника',
  otherOwnerPhone: 'Мобильный телефон',
  otherOwnerMaritalStatus: 'Семейное положение',
  relationship: 'Принадлежность к заёмщику',
  fio: 'Ваше ФИО',
  isPledgeAddressSameRegistration: 'Совпадает с адресом регистрации',
};
